export const EXLY_PHONE_NUMBER = "919870134582";
